import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-shots-list',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    ButtonGroupModule,
    CdkDropList,
    CdkDrag,
  ],
  templateUrl: './shots-list.component.html',
  styleUrl: './shots-list.component.scss',
})
export class ShotsListComponent {
  items = [1, 2, 3, 4, 5, 6];

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
  }
}
